import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DsCheckboxComponent } from './components/checkbox/checkbox.component';

@NgModule({
  imports: [CommonModule],
  declarations: [DsCheckboxComponent],
  exports: [DsCheckboxComponent],
})
export class DsCheckboxModule {}
